import OmniBar from './OmniBar';

export default OmniBar;
